"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigDrumroll = void 0;
const Note_1 = require("../Note");
const NoteType_1 = require("../lib/NoteType");
class BigDrumroll extends Note_1.Note {
    constructor() {
        super(NoteType_1.NoteType.DRUMROLL);
    }
}
exports.BigDrumroll = BigDrumroll;
